import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CallbackComponent} from './callback.component';
import {CallbackRoutingModule} from "./callback-routing.module";
import { CbNaverComponent } from './cb-naver/cb-naver.component';
import {RouterOutlet} from "@angular/router";


@NgModule({
  declarations: [
    CallbackComponent,
    CbNaverComponent,
  ],
  imports: [
    CommonModule,
    CallbackRoutingModule,
    RouterOutlet,
  ],
})
export class CallbackModule {
}
